import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "faceRecognitionFilled"
const FaceRecognitionFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M3.75 20.25H8.25V21.75H3.75C2.922 21.75 2.25 21.078 2.25 20.25V15.75H3.75zM21.75 20.25C21.75 21.078 21.078 21.75 20.25 21.75H15.75V20.25H20.25V15.75H21.75z" />
          <path
            fillRule="evenodd"
            d="M12 5.063C15.832 5.063 18.938 8.169 18.938 12S15.832 18.938 12 18.938 5.063 15.832 5.063 12 8.169 5.063 12 5.063M9.313 13.984C9.497 14.551 9.857 15.045 10.34 15.396 10.822 15.746 11.404 15.935 12 15.935 12.598 15.935 13.18 15.745 13.663 15.395S14.504 14.552 14.689 13.986L14.769 13.738H9.232zM9.187 9.75C8.67 9.75 8.25 10.17 8.25 10.688 8.25 11.205 8.67 11.625 9.188 11.625 9.705 11.625 10.125 11.205 10.125 10.688S9.705 9.75 9.188 9.75M14.814 9.75C14.295 9.75 13.875 10.17 13.875 10.688 13.875 11.205 14.295 11.625 14.813 11.625 15.33 11.625 15.75 11.205 15.75 10.688S15.33 9.75 14.813 9.75"
            clipRule="evenodd"
          />
          <path d="M8.25 3.75H3.75V8.25H2.25V3.75C2.25 2.922 2.922 2.25 3.75 2.25H8.25zM20.25 2.25C21.078 2.25 21.75 2.922 21.75 3.75V8.25H20.25V3.75H15.75V2.25z" />
        </svg>
      }
    </span>
  )
}
export default FaceRecognitionFilledIcon
